import React, { useState } from 'react'
import Button from '@components/common/Button/Button.component'
import './CallSummary.css'
import { ScheduleAppointment } from '@components/layout/Modals'
import {
  AppointmentRequest,
  AppointmentResponse,
} from '@dataTypes/appointment.type'
import { addAppointment } from '@store/actions/appointment.action'
import { useAppDispatch } from '@store/hooks'
import moment from 'moment'

type CallSummaryProps = {
  aiCallSummary?: string
  senderType: 'client' | 'clinic' | 'ai' | 'at-modal'
  showLeftIcon?: boolean
}

const CallSummary: React.FC<CallSummaryProps> = ({
  aiCallSummary,
  senderType,
  showLeftIcon = true,
}) => {
  const dispatch = useAppDispatch()
  const [isApptModalOpen, setIsApptModalOpen] = useState(false)
  const handleModal = (
    isOpen: boolean,
    appt: AppointmentResponse | null = null,
  ): void => {
    setIsApptModalOpen(isOpen)
  }

  const handleOnSave = (apptDetails: Partial<AppointmentRequest>): void => {
    dispatch(
      addAppointment({
        appointmentData: apptDetails,
        date: moment().format('MMMM D, YYYY'),
        activeTab: 'day',
      }),
    )
  }

  return (
    <>
      <div className="call-summary-modal-container">
        <span className="header">AI call summary</span>
        {aiCallSummary
          ? aiCallSummary
              .split('\n')
              .map((line) => line.trim().replace(/^-+\s*/, ''))
              .filter(Boolean)
              .map((data, index) => (
                <span key={index} className="summary-item">
                  <span className="ti ti-circle-filled bullet-icon" />
                  {data}
                  <br />
                </span>
              ))
          : 'No AI Summary found'}
        <span className="secondary-header">Suggestions</span>
        <Button
          size="xs"
          className="button-primary suggestion-btn"
          onClick={() => {
            handleModal(true)
          }}
        >
          Set appointment
        </Button>
      </div>
      {isApptModalOpen && (
        <ScheduleAppointment
          isOpen={isApptModalOpen}
          handleModal={() => handleModal(false)}
          onSave={handleOnSave}
        />
      )}
    </>
  )
}

export default CallSummary
